import { Statistics } from "@mezo/api"
import { MezoStablecoins, MezoTokens, SupportedTokenName } from "@mezo/sdk"

import abtcTokenLogo from "#/assets/tokens/abtc-token.svg"
import bitcoinTokenLogo from "#/assets/tokens/bitcoin-token-orange.svg"
import cbBtcTokenLogo from "#/assets/tokens/cbbtc-token.svg"
import crvsusdTokenLogo from "#/assets/tokens/crvusd-token.svg"
import daiTokenLogo from "#/assets/tokens/dai-token.svg"
import fbtcTokenLogo from "#/assets/tokens/fbtc-token.svg"
import intbtcTokenLogo from "#/assets/tokens/intbtc-token.svg"
import lBtcTokenLogo from "#/assets/tokens/lbtc-token.svg"
import musdTokenLogo from "#/assets/tokens/musd-token.svg"
import musdTokenTestnetLogo from "#/assets/tokens/musd-token-testnet.svg"
import solvbtcTokenLogo from "#/assets/tokens/solvbtc-token.svg"
import swBtcTokenLogo from "#/assets/tokens/swbtc-token.svg"
import tTokenLogo from "#/assets/tokens/t-token.svg"
import tbtcTokenLogo from "#/assets/tokens/tbtc-token.svg"
import thusdTokenLogo from "#/assets/tokens/thusd-token.svg"
import usdcTokenLogo from "#/assets/tokens/usdc-token.svg"
import usdeTokenLogo from "#/assets/tokens/usde-token.svg"
import usdtTokenLogo from "#/assets/tokens/usdt-token.svg"
import wbtcTokenLogo from "#/assets/tokens/wbtc-token.svg"
import wmTokenLogo from "#/assets/tokens/wm-token.svg"
import xsolvbtcTokenLogo from "#/assets/tokens/xsolvbtc-token.svg"
import { PortalToken } from "#/shared/types"

import { DISABLED_ASSETS } from "./env"
import { IS_MEZO_MAINNET } from "./network"

export const ONE_BITCOIN_IN_SATOSHI = 10 ** 8

export const PORTAL_STABLECOINS: PortalToken<keyof MezoStablecoins>[] = [
  { token: "USDC", icon: usdcTokenLogo },
  { token: "USDT", icon: usdtTokenLogo },
  { token: "USDe", icon: usdeTokenLogo, invertColorOnHover: true },
  { token: "crvUSD", icon: crvsusdTokenLogo },
  { token: "thUSD", icon: thusdTokenLogo },
  { token: "DAI", icon: daiTokenLogo },
  { token: "wM", icon: wmTokenLogo },
  { token: "T", icon: tTokenLogo },
]

export const BITCOIN_TOKENS: PortalToken<keyof MezoTokens>[] = [
  { token: "BTC", icon: bitcoinTokenLogo },
  { token: "tBTC", icon: tbtcTokenLogo, invertColorOnHover: true },
  { token: "WBTC", icon: wbtcTokenLogo, invertColorOnHover: true },
  { token: "fBTC", icon: fbtcTokenLogo },
  { token: "SolvBTC", icon: solvbtcTokenLogo },
  { token: "xSolvBTC", icon: xsolvbtcTokenLogo },
  { token: "swBTC", icon: swBtcTokenLogo },
  { token: "cbBTC", icon: cbBtcTokenLogo },
  { token: "LBTC", icon: lBtcTokenLogo },
  { token: "aBTC", icon: abtcTokenLogo },
  { token: "intBTC", icon: intbtcTokenLogo },
]

const mUsdToken: PortalToken<SupportedTokenName> = {
  token: "MUSD",
  icon: IS_MEZO_MAINNET ? musdTokenLogo : musdTokenTestnetLogo,
}

const crvStbtcToken: PortalToken<SupportedTokenName> = {
  token: "crv-stBTC",
  icon: bitcoinTokenLogo, // we don't have this token logo so we are using BTC
}

export const stablecoinNames = PORTAL_STABLECOINS.map((token) => token.token)
export const bitcoinTokenNames = BITCOIN_TOKENS.map((token) => token.token)

export const PORTAL_TOKENS: PortalToken<SupportedTokenName>[] = [
  ...BITCOIN_TOKENS,
  ...PORTAL_STABLECOINS,
].filter(({ token }) => !DISABLED_ASSETS.includes(token))

export const SWAP_TOKENS: PortalToken<SupportedTokenName>[] = [
  BITCOIN_TOKENS[0],
  mUsdToken,
]

export const ALL_TOKENS = [
  ...PORTAL_STABLECOINS,
  ...BITCOIN_TOKENS,
  mUsdToken,
  crvStbtcToken,
]

export const SPECIAL_PRICE_TOKENS: Partial<
  Record<SupportedTokenName, keyof Statistics>
> = { T: "currentUsdPerTToken" }

export const TOKEN_TO_SYMBOL: Record<SupportedTokenName, string> = {
  BTC: "BTC",
  tBTC: "tBTC",
  WBTC: "WBTC",
  fBTC: "fBTC",
  SolvBTC: "SolvBTC",
  xSolvBTC: "xSolvBTC",
  thUSD: "thUSD",
  USDe: "USDe",
  USDC: "USDC",
  USDT: "USDT",
  crvUSD: "crvUSD",
  DAI: "DAI",
  stBTC: "stBTC",
  "crv-stBTC": "crv-stBTC",
  swBTC: "swBTC",
  cbBTC: "cbBTC",
  LBTC: "LBTC",
  aBTC: "aBTC",
  intBTC: "intBTC",
  wM: "wM",
  T: "T",
  mBTC: IS_MEZO_MAINNET ? "BTC" : "mBTC",
  MUSD: "MUSD",
}
